import "./ArReceipt.scss";
import AllDocsNote from "../../../components/allDocsNote/AllDocsNote.jsx";
import AllFiles from "../../../components/allFiles/AllFiles.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
  CustomButtonSmall,
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import { fetchClientsBySearch, fetchMainLedgers, fetchSubLedgers, formatAmountsToDecimals, formatNumber, formatStringToNumberV2, getCssValue, logData, numberToWordsWithDecimal } from "../../../utils/genericFunctions.js";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination
} from "@mui/material";
import DOMPurify from 'dompurify';
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import Badge from '@mui/material/Badge';
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import { useEffect, useRef, useState, useMemo, } from "react";
import Confetti from "react-confetti";
import { IoChatbubbles, IoClose, IoDocumentTextSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { ScaleLoader } from "react-spinners";
import FileUploadComponent from "../../../components/fileUploadComponent/FileUploadComponent.jsx";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages.jsx";
import EmailComponent from "../../../components/emailComponent/EmailComponent.jsx";
import Correspondence from "../../../components/correspondence/Correspondence.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import TagIcon from '@mui/icons-material/Tag';
import { TbCertificate } from "react-icons/tb";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import HRHandbook from "../../../components/test/HRHandbook.jsx";
import { useTranslation } from "react-i18next";
import { MdAdd, MdAlternateEmail, MdClose, MdDelete, MdEditDocument, MdForum, MdPhone, MdRefresh, MdSave, MdSms } from "react-icons/md";
import Taccount from "../../../components/taccount/Taccount.jsx";
import { RiAttachment2 } from "react-icons/ri";
import { HiOutlineLink } from "react-icons/hi2";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";
import { CustomRadioGroup } from "../../../components/radio/CustomRadioGroup.jsx";
import Collaborator from "../../../components/Collaborator/Collaborator.jsx";


const ArReceipt = () => {
  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);

  const [isCollabOpen, setIsCollabOpen] = useState(false);
  const openCollab = () => setIsCollabOpen(true);
  const closeCollab = () => setIsCollabOpen(false);
  const pageShellRef = useRef(null);
  const [collabRightOffset, setCollabRightOffset] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const navigate = useNavigate();
  const [receiptData, setReceiptData] = useState(null);
  const [figuresToShow, setFiguresToShow] = useState("org");
  const { docid } = useParams();
  const [receiptDocId, setReceiptDocId] = useState(null);
  const clientRef = useRef(null);
  const miscNameRef = useRef(null);
  const payingForRef = useRef(null);
  const glDateRef = useRef(null);
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailData, setEmailData] = useState(null);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [documentEnabled, setDocumentEnabled] = useState("Y");
  const [nextAction, setNextAction] = useState("Validate");
  const [isConfettiActive, setIsConfettiActive] = useState(false);
  const [validationMsgDialog, setValidationMsgDialog] = useState(false);
  const [validationMessagesResult, setValidationMessagesResult] = useState({});
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
  });
  const [invokedAction, setInvokedAction] = useState("");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [numGeneration, setNumGeneration] = useState({});
  let generatedDocNo = "";
  let isDocumentNumberSetup = false;
  const [hdNo, setHdNo] = useState(null);
  const [hdCurCode, setHdCurCode] = useState({
    value: "",
    label: "",
  });
  const [traceData, setTraceData] = useState([]);
  const [hdCurRate, setHdCurRate] = useState(1);
  const [currencies, setCurrencies] = useState([]);
  const [hdNarration, setHdNarration] = useState(null);
  const [hdRefNo, setHdRefNo] = useState(null);
  const [hdAcNo, setHdAcNo] = useState(null);
  const [hdType, setHdType] = useState("Normal");
  const [bankAccounts, setBankAccounts] = useState([]);
  const [hdBizUnit, setHdBizUnit] = useState(null);
  const [branches, setBranches] = useState([]);
  const [hdGlDate, setHdGlDate] = useState(null);
  const [hdMode, setHdMode] = useState(null);
  const [receiptMode, setReceiptMode] = useState([]);
  const [hdStatus, setHdStatus] = useState("New");
  const [hdPayingFor, setHdPayingFor] = useState(null);
  const [payingFor, setPayingFor] = useState([]);
  const [hdEntCode, setHdEntCode] = useState(null);
  const [hdChqNo, setHdChqNo] = useState(null);
  const [hdChqBank, setHdChqBank] = useState(null);
  const [hdChqDate, setHdChqDate] = useState(null);
  const [hdFcAmount, setHdFcAmount] = useState("");
  const [hdLcAmount, setHdLcAmount] = useState("");

  const [hdMiscName, setHdMiscName] = useState("");
  const [hdMiscEmail, setHdMiscEmail] = useState("");
  const [hdMiscPhone, setHdMiscPhone] = useState("");
  const [hdMiscIdnumber, setHdMiscIdnumber] = useState("");
  const [hdMglCode, setHdMglCode] = useState(null);
  const [hdMglSubType, setHdMglSubType] = useState(null);
  const [hdSglCode, setHdSglCode] = useState(null);
  const [hdMiscTaxPin, setHdMiscTaxPin] = useState("");
  const [hdMiscRefNo, setHdMiscRefNo] = useState("");

  const [hdWhichYear, setHdWhichYear] = useState(null);
  const [hdWhichPeriod, setHdWhichPeriod] = useState(null);
  const [payingYears, setPayingYears] = useState([]);
  const [payingPeriods, setPayingPeriods] = useState([]);

  const [allocatedFcAmountXx, setAllocatedFcAmountXx] = useState(0);
  const [allocatedLcAmountXx, setAllocatedLcAmountXx] = useState(0);
  const [netoffCommission, setNetoffCommission] = useState("Y");

  const [maxMatchFcAmount, setMaxMatchFcAmount] = useState();
  const [maxMatchLcAmount, setMaxMatchLcAmount] = useState();

  const [matchedFcAmount, setMatchedFcAmount] = useState();
  const [matchedLcAmount, setMatchedLcAmount] = useState();
  const [matchedCommFc, setMatchedCommFc] = useState();
  const [matchedCommLc, setMatchedCommLc] = useState();

  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [entityPolicies, setEntityPolicies] = useState([]);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [installments, setInstallments] = useState([]);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const investorRef = useRef(null);
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [receiptLines, setReceiptLines] = useState([]);
  const [selectedReceiptLine, setSelectedReceiptLine] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);


  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setCurrentPage(0);
  };

  const slicedReceiptLines = receiptLines.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const customNoOptionsMessage = (customMessage) => {
    return (
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1 className="sub-title" >
          {customMessage}
        </h1>
        <CustomButtonSmall
          onClick={() => navigate("/entity/new")}
        >
          {t('create')}
        </CustomButtonSmall>
      </span>
    );
  };

  const fetchReceiptLines = async (hdNo, receiptDocid) => {
    try {
      const res = await newRequest.post("/arReceiptLn/findAll", {
        ln_hd_no: hdNo,
        ln_hd_no_docid: receiptDocid,
      });

      const formattedLines = res.data?.map(line => ({
        ...line,
        ln_fc_amount: formatAmountsToDecimals(line?.ln_fc_amount || 0),
        ln_lc_amount: formatAmountsToDecimals(line?.ln_lc_amount || 0),
      }));

      setReceiptLines(formattedLines);
    } catch (err) {
      console.log(err);
    }
  };


  const fetchEntityPolicies = async (entCode) => {
    try {
      if (entCode) {
        const res = await newRequest.post(
          "/uwPolicy/entityPolicies",
          {
            doc_types: ["Policy", "RiskNote"],
            pl_status: "Active",
            ent_code: entCode
          }
        );
        const options = res.data.map((rn) => ({
          pl_risk_note_no: rn?.pl_risk_note_no,
          pl_type: rn?.pl_type,
          pl_no: rn?.pl_no,
          pl_end_no: rn?.pl_end_no,
          endorsement_name: rn?.endorsement_name,
          pl_docid: rn?._id,
          pl_assr_ent_code: rn?.pl_assr_ent_code,
          pl_ins_ent_code: rn?.pl_ins_ent_code,
          value: `${currentUser?.token_org_type === "insurance" ? rn?.pl_no : rn?.pl_risk_note_no} - ${rn?.endorsement_name}`,
          label: `${currentUser?.token_org_type === "insurance" ? rn?.pl_no : rn?.pl_risk_note_no} - ${rn?.endorsement_name}`,
        }));

        // console.log(`setEntityRiskNotes ${JSON.stringify(options, null, 2)}`);
        setEntityPolicies(options);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTrace = async (receiptNo) => {
    try {
      const res = await newRequest.post(
        "/trace/findDoc",
        {
          trc_doc_type: "AR Receipt",
          trc_doc_no: receiptNo
        }
      );
      setTraceData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPolicyInstallments = async (policy_docid) => {
    try {
      const res = await newRequest.post("/uwPolicy/osInstallment", { policy_docid });
      const options = res.data.map((ins) => ({
        ins_fc_amount: ins.ins_fc_amount,
        ins_lc_amount: ins.ins_lc_amount,
        os_fc_amount_xx: ins.os_fc_amount_xx,
        os_lc_amount_xx: ins.os_lc_amount_xx,
        value: ins.ins_no,
        label: ins.fmt_ins_date_xx,
      }));

      setInstallments(options);
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddMatchingDoc = async () => {
    try {

      if (!selectedPolicy) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please select document to match!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!selectedInstallment) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please select installment!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!matchedFcAmount) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please enter amount to match!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      // check if entered amount is greater that document outstanding
      if (matchedFcAmount > maxMatchFcAmount) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(
          `Total outstanding to match is <strong>${hdCurCode?.value} ${numeral(
            maxMatchFcAmount
          ).format("0,0.00")}</strong>. You CANNOT match more than this amount`
        );
        setIsNotifyDialogOpen(true);
        return;
      }

      setIsProcessing(true);
      // console.log(`selectedInstallment ${JSON.stringify(selectedInstallment, null, 2)}`);
      // console.log(`selectedPolicy ${JSON.stringify(selectedPolicy, null, 2)}`);
      // insert receipt line
      const res = await newRequest.post("/arReceiptLn/add", {
        ln_hd_no: hdNo,
        ln_hd_no_docid: receiptData?._id,
        ln_doc_type: selectedPolicy?.pl_type,
        ln_doc_no: selectedPolicy?.pl_risk_note_no,
        ln_doc_docid: selectedPolicy?.pl_docid,
        ln_hd_status: hdStatus,
        ln_paying_for: hdPayingFor?.value,
        ln_doc_ins_no: selectedInstallment?.value,
        ln_fc_amount: formatStringToNumberV2(matchedFcAmount),
        ln_lc_amount: formatStringToNumberV2(matchedLcAmount),
        ln_doc_amount_fc: selectedInstallment?.os_fc_amount_xx || 0,
        ln_doc_amount_lc: selectedInstallment?.os_lc_amount_xx || 0,
        ln_ent_code: hdEntCode?.value,
        ln_insured_ent_code: selectedPolicy?.pl_assr_ent_code,
        ln_carrier_ent_code: selectedPolicy?.pl_ins_ent_code,
        ln_comm_fc: 0,
        ln_comm_lc: 0,
        ln_narration: "Matched"
      });

      // console.log(`arReceiptLn/add ${JSON.stringify(res.data, null, 2)}`);

      if (res.data.msg === "exists") {
        showToast(
          `Document ${selectedPolicy?.label} already attached`,
          "error"
        );
      } else {

        // update installment has been matched

        try {
          await newRequest.post("/trace/add", {
            trc_action_on: "Document",
            trc_doc_type: "Receipt",
            trc_doc_no: receiptData.hd_no,
            trc_doc_docid: receiptDocId,
            trc_aent_code: hdEntCode?.ent_aent_code,
            trc_ent_code: hdEntCode?.ent_code,
            trc_action: "matched document",
            trc_remarks: `matched ${selectedPolicy?.pl_risk_note_no} totaling ${matchedFcAmount} to this receipt`,
            trc_tags: [`matching`]
          });
        } catch (error) {
          console.log(error);
        }

        //  if receipt already approved, add to the policy receipt also
        // if (hdStatus === "Approved") {
        //   try {
        //     await newRequest.post(
        //       "/arReceiptHdr/mergeMatched",
        //       {
        //         ln_hd_no: hdNo,
        //         ln_hd_no_docid: receiptData._id,
        //         receipt_mode: hdMode.value,
        //         receipt_date: hdGlDate,
        //         receipt_currency: hdCurCode.value
        //       });
        //   } catch (error) {
        //     console.log(error);
        //   }
        // }
        setMatchedFcAmount(0);
        setMatchedLcAmount(0);
        setMaxMatchFcAmount(0);
        setMaxMatchLcAmount(0);
        setMatchedCommFc(0);
        setMatchedCommLc(0);
        setSelectedPolicy({
          pl_risk_note_no: "",
          pl_type: "",
          pl_no: "",
          pl_end_no: "",
          pl_docid: "",
          pl_assr_ent_code: "",
          pl_ins_ent_code: "",
          value: "",
          label: "",
        });

        await fetchReceipt(receiptData._id);
        // removeRisknoteById();
        showToast(
          `Document ${selectedPolicy?.pl_no} added`,
          "success"
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsProcessing(false);
    }
  };


  const addDefaultInvestLine = async () => {
    try {
      await newRequest.post("/arReceiptLn/add", {
        ln_hd_no: hdNo,
        ln_hd_no_docid: receiptData?._id,
        ln_doc_type: "Entity",
        ln_doc_no: "",
        ln_doc_docid: "",
        ln_hd_status: hdStatus,
        ln_paying_for: hdPayingFor?.value,
        ln_doc_ins_no: "",
        ln_fc_amount: formatStringToNumberV2(hdFcAmount),
        ln_lc_amount: formatStringToNumberV2(hdLcAmount),
        ln_doc_amount_fc: 0,
        ln_doc_amount_lc: 0,
        ln_ent_code: hdEntCode?.value,
        ln_comm_fc: 0,
        ln_comm_lc: 0,
        ln_narration: "Matched"
      });
    } catch (error) {
      console.log(error)
    }
  };

  const removeRisknoteById = (id) => {
    try {
      const updatedData = entityPolicies.filter(item => item._id !== id);
      setEntityPolicies(updatedData);
    } catch (error) {
      console.log(error)
    }
  };


  const handleMatchedFcAmountBlur = (e) => {
    if (e.target.value) {
      const strippedValue = e.target.value.replace(/,/g, "");
      if (isNaN(strippedValue)) {
        setMatchedFcAmount("");
        setNotifyDialogTitle("Error!");
        setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
        setIsNotifyDialogOpen(true); return;
      }

      setMatchedFcAmount(formatAmountsToDecimals(strippedValue, 2));
      const lcAmount = Number(parseFloat(strippedValue * hdCurRate).toFixed(4));
      setMatchedLcAmount(lcAmount);

    }
  };

  const handleMatchedCommFcBlur = (e) => {
    if (e.target.value) {
      const strippedValue = e.target.value.replace(/,/g, ""); // Remove commas
      const parsedValue = formatAmountsToDecimals(strippedValue || 0, 2);
      setMatchedCommFc(parsedValue);
      const lcAmount = Number(parseFloat(parsedValue * hdCurRate).toFixed(4));
      setMatchedCommLc(lcAmount);
    }
  };

  const handleFcAmountBlur = (e) => {
    try {
      if (e.target.value) {
        const strippedValue = e.target.value.replace(/,/g, "");
        if (isNaN(strippedValue)) {
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
          setIsNotifyDialogOpen(true);
          return;
        }

        setHdFcAmount(formatAmountsToDecimals(strippedValue, 2));
        const lcAmount = Number(parseFloat(strippedValue * hdCurRate).toFixed(4));
        setHdLcAmount(lcAmount);

      }
    } catch (error) {
      console.log(error)
    }
  };

  const handleCurRateBlur = (e) => {
    try {
      if (e.target.value) {
        const strippedValue = e.target.value.replace(/,/g, "");
        if (isNaN(strippedValue)) {
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
          setIsNotifyDialogOpen(true);
          return;
        }
        setHdCurRate(formatAmountsToDecimals(strippedValue, 4));
        const lcAmount = Number(parseFloat(hdFcAmount * formatAmountsToDecimals(strippedValue, 4)).toFixed(4));
        setHdLcAmount(lcAmount);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const handleGlDateChange = async (e) => {
    try {
      if (e.target.value) {
        const formattedGlDate = moment(e.target.value).format("YYYY-MM-DD");
        setHdGlDate(formattedGlDate);
        if (hdCurCode.value !== currentUser?.currency_code_xx) {

          // console.log(`curRate  ${JSON.stringify(curRate, null, 2)}`);
          // get rate
          const res = await newRequest.post("/glCurrencyRate/find", {
            rate_cur_code_fm: hdCurCode.value,
            rate_cur_code_to: currentUser?.currency_code_xx,
            rate_date: formattedGlDate,
          });
          if (!res.data || !res.data?.rate) {
            setHdCurCode({
              value: currentUser.currency_code_xx,
              label: currentUser.currency_name_xx,
            });
            setHdCurRate(1);
            setNotifyDialogTitle(t('note'));
            setNotifyDialogText(
              `Conversion Rate from <strong>${hdCurCode.value
              } to ${currentUser.currency_code_xx
              } for date ${moment(hdGlDate).format(
                "DD-MMM-YYYY"
              )}</strong> NOT found. Currency will reset to <strong>${currentUser.currency_code_xx
              }</strong>`
            );
            setIsNotifyDialogOpen(true);
          } else {
            setHdCurRate(res.data.rate);
          }
        } else {
          setHdCurRate(1);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  const fetchReceipt = async (doc_id, firstTime = false) => {
    try {
      if (doc_id && doc_id !== "new") {
        if (firstTime) {
          setIsLoading(true);
        }
        const res = await newRequest.get(`/arReceiptHdr/findById/${doc_id}`);

        if (res.data) {
          setReceiptData(res.data);
          setReceiptDocId(res.data._id);
          // set receipt information
          if (res.data?.hd_no) {
            setHdNo(res.data?.hd_no);
          }

          if (res.data?.hd_type) {
            setHdType(res.data?.hd_type);
          }

          if (res.data?.hd_status) {
            setHdStatus(res.data?.hd_status);
          }

          if (res.data?.hd_cur_rate) {
            setHdCurRate(res.data?.hd_cur_rate);
          }
          if (res.data?.hd_narration) {
            setHdNarration(res.data?.hd_narration);
          }
          if (res.data?.hd_ref_no) {
            setHdRefNo(res.data?.hd_ref_no);
          }
          if (res.data?.hd_chq_no) {
            setHdChqNo(res.data?.hd_chq_no);
          }
          if (res.data?.hd_chq_bank) {
            setHdChqBank(res.data?.hd_chq_bank);
          }

          if (res.data?.hd_chq_date) {
            const formattedChqDate = moment(res.data?.hd_chq_date).format(
              "YYYY-MM-DD"
            );
            setHdChqDate(formattedChqDate);
          }

          if (res.data?.hd_fc_amount) {
            const formattedValue = formatAmountsToDecimals(res.data?.hd_fc_amount, 2);
            setHdFcAmount(formattedValue)
          }

          if (res.data?.hd_lc_amount) {
            setHdLcAmount(res.data?.hd_lc_amount);
          }

          if (res.data?.hd_biz_unit) {
            setHdBizUnit({
              value: res.data?.hd_biz_unit,
              label: res.data.bizunit_name_xx,
            });
          }

          if (res.data?.hd_gl_date) {
            const formattedGlDate = moment(res.data?.hd_gl_date).format(
              "YYYY-MM-DD"
            );
            setHdGlDate(formattedGlDate);
          }

          if (res.data?.hd_cur_code) {
            setHdCurCode({
              value: res.data?.hd_cur_code,
              label: res.data.currency_xx,
            });
          }

          if (res.data?.hd_mode) {
            setHdMode({
              value: res.data?.hd_mode,
              label: res.data.receipt_mode_xx,
            });
          }

          if (res.data?.hd_paying_for) {
            setHdPayingFor({
              value: res.data?.hd_paying_for,
              label: res.data.paying_for_xx,
            });
          }

          if (res.data?.hd_which_year) {
            setHdWhichYear({
              value: res.data?.hd_which_year,
              label: res.data?.hd_which_year,
            });
          }

          if (res.data?.hd_which_period) {
            setHdWhichPeriod({
              value: res.data?.hd_which_period,
              label: res.data?.hd_which_period,
            });
          }


          if (res.data.bank_ac_no_xx) {
            setHdAcNo({
              bank_code: res.data.bank_code_xx,
              branch_code: res.data.bank_branch_code_xx,
              value: res.data.bank_ac_no_xx,
              label: res.data.bank_ac_name_xx,
            });
          }

          if (res.data?.hd_ent_code) {
            setHdEntCode({
              ent_email: res.data.client_details_xx.ent_email,
              ent_phone_no: res.data.client_details_xx.ent_phone_no,
              ent_photo_url: res.data.client_details_xx.ent_photo_url,
              ent_status: res.data.client_details_xx.ent_status,
              aent_name_xx: res.data.client_details_xx.aent_name_xx,
              ent_code: res.data?.hd_ent_code,
              ent_aent_code: res.data?.hd_aent_code,
              ent_name: res.data.client_details_xx.ent_name,
              value: res.data?.hd_ent_code,
              label: res.data.client_details_xx.ent_name,
            });
          }

          // Miscellanous receipt detailts
          setHdMiscName(res.data?.hd_misc_name);
          setHdMiscEmail(res.data?.hd_misc_email);
          setHdMiscPhone(res.data?.hd_misc_phone);
          setHdMiscIdnumber(res.data?.hd_misc_idnumber);
          setHdMiscTaxPin(res.data?.hd_misc_tax_pin);
          setHdMiscRefNo(res.data?.hd_misc_ref_no);
          setHdMglSubType(res.data?.hd_mgl_sub_type);

          if (res.data?.hd_mgl_code) {
            setHdMglCode({
              value: res.data?.hd_mgl_code,
              label: res.data?.hd_mgl_code_xx
            });
          } else {
            setHdMglCode(null);
          }

          if (res.data?.hd_sgl_code) {
            setHdSglCode({
              value: res.data?.hd_sgl_code,
              label: res.data?.hd_sgl_code_xx
            });
          } else {
            setHdSglCode(null);
          }

          setDocumentEnabled(res.data.document_enabled_xx);
          setNextAction(res.data.next_action_xx);
          await fetchTrace(res.data?.hd_no);
          await fetchReceiptLines(res.data?.hd_no, res.data._id);
          await fetchEntityPolicies(res.data?.hd_ent_code);
        }
        // fetch attachments
        fetchDocumentAttachments("AR Receipt", res.data._id);
      }
    } catch (err) {
      console.log(err);
    } finally {
      if (firstTime) {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    const compute = () => {
      const el = pageShellRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      // how much “empty space” exists on the right side of the centered/max-width container
      const offset = Math.max(0, window.innerWidth - rect.right);
      setCollabRightOffset(offset);
    };

    compute();

    window.addEventListener("resize", compute);
    // optional: if your layout can shift on scroll due to sticky headers etc.
    window.addEventListener("scroll", compute, true);

    return () => {
      window.removeEventListener("resize", compute);
      window.removeEventListener("scroll", compute, true);
    };
  }, []);


  // calculate total allocation
  useEffect(() => {
    if (!Array.isArray(receiptLines)) return;

    let fcTotal = 0;
    let lcTotal = 0;
    // console.log(`receiptLines ${JSON.stringify(receiptLines, null, 2)}`);
    for (const item of receiptLines) {
      const fc = parseFloat(formatStringToNumberV2(item?.ln_fc_amount || 0)) || 0;
      const lc = parseFloat(formatStringToNumberV2(item?.ln_lc_amount || 0)) || 0;
      fcTotal += isNaN(fc) ? 0 : fc;
      lcTotal += isNaN(lc) ? 0 : lc;
    }
    // console.log(`first fcTotal ${fcTotal} and lcTotal ${lcTotal}`);
    setAllocatedFcAmountXx(fcTotal);
    setAllocatedLcAmountXx(lcTotal);
  }, [receiptLines]);



  const fetchBranches = async () => {
    try {
      const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });
      const options = res.data.map((branch) => ({
        value: branch?.unit_code,
        label: branch?.unit_name,
      }));
      setBranches(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const res = await newRequest.get("/glCurrency/findAll");
      const options = res.data.map((currency) => ({
        value: currency.cur_code,
        label: currency.cur_name,
      }));
      setCurrencies(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchBankAccounts = async () => {
    try {
      const res = await newRequest.get("/glBankAc/findAll");

      // Filter the bank accounts based on the specified conditions
      const filteredAccounts = res.data.filter((bank) =>
        bank?.ac_status === "Active" &&
        bank?.ac_visible === "Y" &&
        bank?.ac_receipt === "Y"
      );

      // Map the filtered accounts to the desired options format
      const options = filteredAccounts.map((bank) => ({
        bank_code: bank?.bank_code_xx,
        branch_code: bank?.bank_branch_code_xx,
        value: bank?.ac_no,
        label: bank?.ac_name,
      }));

      setBankAccounts(options);

      if (receiptDocId === "new") {
        setHdAcNo({
          bank_code: filteredAccounts[0]?.bank_code_xx,
          branch_code: filteredAccounts[0]?.bank_branch_code_xx,
          value: filteredAccounts[0]?.ac_no,
          label: filteredAccounts[0]?.ac_name,
        });
      }
    } catch (error) {
      console.error("Error fetching bank accounts :", error);
    }
  };

  // fetch number generation code
  const fetchNumberGeneration = async () => {
    try {
      const res = await newRequest.post("/orgNumgen/find", { gen_type: "Receipt" },);
      setNumGeneration(res.data);
      isDocumentNumberSetup = true;
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDocumentAttachments = async (docType, docid) => {
    try {
      const res = await newRequest.post(
        "/files/findDocFiles",
        {
          fl_doc_type: docType,
          fl_parent_doc_id: docid,
        },

      );

      setAttachmentsData(res.data);
    } catch (err) {
      console.log(err);
    }
  };


  const fetchYears = async () => {
    try {
      // console.log(`fetching periods for ${fy}`);
      const res = await newRequest.post("/glCy/findAll", { cy_type: "Financial" });
      // console.log(`fetchPeriods  ${JSON.stringify(res.data, null, 2)}`);
      const options = res.data.map((mode) => ({
        value: mode?.cy_code,
        label: mode?.cy_code,
      }));
      setPayingYears(options);
    } catch (error) {
      console.error("Error fetching years :", error);
    }
  };

  const fetchPeriods = async (fy) => {
    try {
      // console.log(`fetching periods for ${fy}`);
      const res = await newRequest.post("/glCp/findAll", { cp_cy_code: fy });
      // console.log(`fetchPeriods  ${JSON.stringify(res.data, null, 2)}`);
      const options = res.data.map((mode) => ({
        value: mode?.cp_code,
        label: mode?.cp_code,
      }));
      setPayingPeriods(options);
    } catch (error) {
      console.error("Error fetching periods :", error);
    }
  };

  const fetchReceiptMode = async () => {
    try {
      const res = await newRequest.post(
        "/sysCode/findAll", { sys_type: "Receipt Mode" }
      );
      const options = res.data.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setReceiptMode(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };


  const callDetailsFunction = async () => {
    try {
      await fetchBankAccounts();
      await fetchCurrencies();
      await fetchBranches();
      await fetchReceiptMode();
      await fetchPayingFor();
      await fetchYears();
    } catch (err) {
      console.log(err);
    }
  };

  const getSystypeToUse = () => {
    switch (currentUser?.token_org_type) {
      case 'insurance':
        return "Paying For";
      case 'agent':
        return "Paying For";
      case 'broker':
        return "Paying For";
      case 'investment':
        return "AM Paying For";
      case 'regulator':
        return "REG Paying For";
      default:
        return "Paying For";
    }
  };

  const fetchPayingFor = async () => {
    try {

      const res = await newRequest.post("/sysCode/findAll", { sys_type: getSystypeToUse() });

      const options = res.data.map((mode) => ({
        value: mode?.sys_code,
        label: mode?.sys_name,
      }));
      setPayingFor(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  // generate document number
  const generateDocumentNo = async () => {
    try {
      const res = await newRequest.post("/orgNumgen/gen", { gen_type: "Receipt", },);
      generatedDocNo = res.data;
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfettiClick = () => {
    setIsConfettiActive(true);
    // Set a timeout to stop the confetti after a few seconds (optional)
    setTimeout(() => {
      setIsConfettiActive(false);
    }, 5000); // Stop confetti after 3 seconds
  };



  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "receiptAction") {

        if ((formatStringToNumberV2(hdFcAmount) - allocatedFcAmountXx) < 0) {
          setIsConfirmDialogOpen(false);
          setConfirmDialogAction("None");
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(
            `You cannot allocate more than <b>${hdCurCode?.value} ${numeral(formatStringToNumberV2(hdFcAmount)).format("0,0.00")}</b>. You cannot proceed.`
          );
          setIsNotifyDialogOpen(true);
          return;
        }

        // check if period is open
        const formattedGlDate = moment(hdGlDate).format("YYYY-MM-DD");
        const res = await newRequest.post(
          "/glCp/periodStatus",
          {
            cp_cy_type: "Financial",
            gl_date: formattedGlDate,
          },
        );

        if (!res.data?.cp_status) {
          setIsConfirmDialogOpen(false);
          setConfirmDialogAction("None");
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText("Check GL Date");
          setIsNotifyDialogOpen(true);
          if (glDateRef.current) {
            glDateRef.current.focus();
          }
          return;
        }

        if (res.data?.cp_status === "Closed") {
          setIsConfirmDialogOpen(false);
          setConfirmDialogAction("None");
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(
            `Accounting date ${moment(hdGlDate).format(
              "DD-MMM-YYYY"
            )} is within Financial period ${res.data.cp_code
            }. The period is ${res.data.cp_status}. You cannot proceed.`
          );
          setIsNotifyDialogOpen(true);
          return;
        }

        if (["Investment", "Premium"].includes(hdPayingFor?.value) && formatStringToNumberV2(hdFcAmount) !== formatStringToNumberV2(allocatedFcAmountXx)) {
          setIsProcessing(false);
          setIsConfirmDialogOpen(false);
          setNotifyDialogTitle(t('error'));
          setNotifyDialogText(`${t('allocationBalanceError', { param1: hdPayingFor?.value, param2: `${hdCurCode?.value} : ${numeral(allocatedFcAmountXx).format("0,0.00")}`, param3: numeral(hdFcAmount).format("0,0.00") })}`);
          setIsNotifyDialogOpen(true);
          return;
        }

        setIsProcessing(true);

        if (["Approved", "Validated"].includes(objectToAction.new_doc_status)) {
          // do all validations
          let validateResponse = null;
          try {
            validateResponse = await newRequest.get(`/arReceiptHdr/validate/${receiptDocId}`, { timeout: 100000 });
          } catch (error) {
            setIsProcessing(false);
            if (error.code === 'ECONNABORTED') {
              console.error("Request timed out!");
              showToast(t('requestTimedOut'), "error");
            } else {
              console.error("Other error:", error.message);
              showToast(error.message, "error");
            }
          }

          if (validateResponse.data.result_status === "error") {
            setIsProcessing(false);
            setIsConfirmDialogOpen(false);
            setValidationMessagesResult(validateResponse.data);
            setValidationMsgDialog(true);
            return;
          }
        } else if (["Cancelled"].includes(objectToAction.new_doc_status)) {
          // do all validations
          let validateResponse = null;
          try {
            validateResponse = await newRequest.get(`/arReceiptHdr/reverseReceipt/${receiptDocId}`, { timeout: 100000 });
          } catch (error) {
            setIsProcessing(false);
            if (error.code === 'ECONNABORTED') {
              console.error("Request timed out!");
              showToast(t('requestTimedOut'), "error");
            } else {
              console.error("Other error:", error.message);
              showToast(error.message, "error");
            }
          }

          if (validateResponse.data.result_status === "error") {
            setIsProcessing(false);
            setIsConfirmDialogOpen(false);
            setValidationMessagesResult(validateResponse.data);
            setValidationMsgDialog(true);
            return;
          }
        }

        await newRequest.put(`/arReceiptHdr/upd/${receiptData._id}`, { hd_status: objectToAction?.new_doc_status });

        try {
          await newRequest.post(
            "/trace/add",
            {
              trc_action_on: "Document",
              trc_doc_type: "Receipt",
              trc_doc_no: receiptData.hd_no,
              trc_doc_docid: receiptDocId,
              trc_aent_code: "",
              trc_ent_code: "",
              trc_action: "updated document status",
              trc_remarks: `updated receipt to ${objectToAction?.new_doc_status}`,
              trc_tags: [`updated receipt to ${objectToAction?.new_doc_status}`],
            },

          );
        } catch (error) {
          console.log(error);
        }

        // add document in uw commission receipts if its a comission receipt
        if (objectToAction.new_doc_status === "Approved") {
          try {
            // loop to add commission line if its commission
            if (hdPayingFor.value === "Commission") {
              for (let i = 0; i < receiptLines.length; i++) {
                try {
                  await newRequest.post(
                    "/uwPolicyCommPmt/add",
                    {
                      comm_risk_note_no: receiptLines[i].ln_doc_no,
                      comm_policy_docid: receiptLines[i].ln_doc_docid,
                      comm_doc_no: hdNo,
                      comm_mode: hdMode.value,
                      comm_date: hdGlDate,
                      comm_currency: hdCurCode.value,
                      comm_fc_amount: receiptLines[i].ln_fc_amount,
                      comm_lc_amount: receiptLines[i].ln_lc_amount,
                      comm_paid_to: "Receipt",
                      comm_our_docid: receiptData._id
                    },
                  );
                } catch (error) {
                  console.log(error)
                }
              }
            }

            setConfirmDialogAction("None");
            setNotifyDialogTitle(t('success'));
            setNotifyDialogText(`Receipt successfully Approved`);
          } catch (error) {
            console.log(error);
          }
        }

        // if (["Approved"].includes(objectToAction.new_doc_status)) { handleConfettiClick(); }

        await fetchReceipt(receiptDocId);

        setConfirmDialogAction("None");
        setNotifyDialogTitle("Success!");
        setNotifyDialogText(`Receipt successfully Approved`);
        setIsProcessing(false);
      } else if (confirmDialogAction === "unmatchDocument") {
        console.log(`Ummatch document ${objectToAction.object_id}`);
        setIsProcessing(true);
        try {
          const del = await newRequest.delete(`/arReceiptLn/del/${objectToAction.object_id}`);
          // fetchReceipt(receiptDocId);
          setReceiptLines((prev) => prev.filter(report => report._id !== objectToAction.object_id));
          setIsProcessing(false);
          showToast(`Document Unmached!`, "success");
        } catch (error) {
          setIsProcessing(false);
          console.log(error);
        }
      } else if (confirmDialogAction === "voidReceipt") {
        setIsProcessing(true);
        try {
          const res = await newRequest.put(`/arReceiptHdr/upd/${receiptData._id}`, { hd_status: "Voided" });
          setIsProcessing(false);
          if (res.data.msg === "updated") {
            await fetchReceipt(receiptDocId);
            showToast(t('documentVoided', { param1: hdNo }), "success");
          } else {
            setNotifyDialogTitle(t('note'));
            setNotifyDialogText(res.data?.text);
            setIsNotifyDialogOpen(true);
          }
        } catch (error) {
          setIsProcessing(false);
          console.log(error);
        }
      }
    } catch (err) {
      console.log(err);
    }
    setIsConfirmDialogOpen(false);
  };



  const saveRecord = async (e) => {
    try {

      const strippedValue = hdFcAmount.replace(/,/g, "");
      if (isNaN(strippedValue)) {
        setMatchedFcAmount("");
        setNotifyDialogTitle("Error!");
        setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!hdPayingFor) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`You must specify what the receipt is paying for!`);
        setIsNotifyDialogOpen(true);
        if (payingForRef.current) {
          payingForRef.current.focus();
        }
        return;
      }

      if (!hdAcNo) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please select bank account!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!hdMode) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please enter receipt mode!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!hdGlDate) {
        setNotifyDialogTitle(t('note'));
        setNotifyDialogText(`Please enter GL Date!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (["SHIF Corporate", "SHIF Individual"].includes(hdPayingFor?.value)) {
        if (!hdWhichPeriod?.value) {
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(`Please specify period!`);
          setIsNotifyDialogOpen(true);
          return;
        }
      }

      if (hdType === "Normal") {
        if (!hdEntCode) {
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(`Please select account!`);
          setIsNotifyDialogOpen(true);
          if (clientRef.current) {
            clientRef.current.focus();
          }
          return;
        }
      } else if (hdType === "Miscellaneous") {
        if (!hdMiscName) {
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(`Please enter received from!`);
          setIsNotifyDialogOpen(true);
          if (miscNameRef.current) {
            miscNameRef.current.focus();
          }
          return;
        }
      }

      if (["Cheque"].includes(hdMode?.value)) {
        if (!hdChqNo) {
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(`Please specify cheque number!`);
          setIsNotifyDialogOpen(true);
          return;
        }
        if (!hdChqDate) {
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(`Please specify cheque date!`);
          setIsNotifyDialogOpen(true);
          return;
        }
      }

      // Simulate delay for 5 seconds
      // await new Promise((resolve) => setTimeout(resolve, 5000));

      if (receiptDocId === "new" && !hdNo) {
        await generateDocumentNo();
      }

      setIsProcessing(true);
      //prepare data
      const receiptHeader = {
        hd_org_code: currentUser.usr_org_code,
        hd_no: hdNo || generatedDocNo,
        hd_narration: hdNarration || "",
        hd_ref_no: hdRefNo || "",
        hd_ac_no: hdAcNo?.value,
        hd_biz_unit: hdBizUnit?.value,
        hd_gl_date: hdGlDate,
        hd_cur_code: hdCurCode?.value,
        hd_cur_rate: hdCurRate,
        hd_mode: hdMode?.value,
        hd_status: hdStatus,
        hd_paying_for: hdPayingFor?.value,
        hd_aent_code: hdEntCode?.aent_code,
        hd_ent_code: hdEntCode?.value,
        hd_chq_no: hdChqNo || "",
        hd_chq_bank: hdChqBank || "",
        hd_chq_date: hdChqDate,
        hd_fc_amount: parseFloat(formatStringToNumberV2(hdFcAmount || 0, 2)) || 0,
        hd_lc_amount: Number(parseFloat(formatStringToNumberV2(hdFcAmount) * hdCurRate).toFixed(4)) || 0,
        hd_entity_name: hdEntCode?.label?.props?.children[0],
        hd_which_year: hdWhichYear?.value || currentUser?.current_fy_xx,
        hd_which_period: hdWhichPeriod?.value || "",
        hd_type: hdType,
        hd_misc_name: hdMiscName,
        hd_misc_email: hdMiscEmail,
        hd_misc_phone: hdMiscPhone,
        hd_misc_idnumber: hdMiscIdnumber,
        hd_misc_tax_pin: hdMiscTaxPin,
        hd_misc_ref_no: hdMiscRefNo,
        hd_mgl_code: hdMglCode?.value,
        hd_sgl_code: hdSglCode?.value,
        hd_mgl_sub_type: hdMglSubType
      };

      if (receiptDocId === "new") {
        const res = await newRequest.post("/arReceiptHdr/add", receiptHeader);
        setHdNo(generatedDocNo);
        setIsProcessing(false);
        setNotifyDialogTitle(t('success'));
        setNotifyDialogText(t('successSaved', { param1: generatedDocNo }));
        setIsNotifyDialogOpen(true);
        await fetchReceipt(res.data?.doc?._id);
        navigate(`/receipt/${res.data?.doc?._id}`, { replace: true });
      } else {
        // this part fires only if its an investment receipt and no lines have been added yet
        let defaultLineInserted = "N";
        if (hdStatus === "New" &&
          hdNo &&
          hdPayingFor?.value === "Investment" &&
          receiptLines.length === 0) {
          await addDefaultInvestLine();
          defaultLineInserted = "Y";
        }

        // save changed lines
        // const changedLines = receiptLines?.filter(  (obj) => obj.changed_xx === "Y" );
        const changedLines = receiptLines;
        for (let i = 0; i < changedLines.length; i++) {
          const lcAmount = Number(parseFloat(formatStringToNumberV2(changedLines[i].ln_fc_amount) * hdCurRate).toFixed(4));
          await newRequest.put(
            `/arReceiptLn/upd/${changedLines[i]._id}`,
            {
              ln_fc_amount: parseFloat(formatStringToNumberV2(changedLines[i].ln_fc_amount || 0)),
              ln_lc_amount: parseFloat(formatStringToNumberV2(lcAmount || 0)),
            }
          );
        }

        await newRequest.put(`/arReceiptHdr/upd/${receiptDocId}`, receiptHeader);
        setNotifyDialogTitle(t('success'));
        setNotifyDialogText(t('successSaved', { param1: hdNo || generatedDocNo }));

        if (defaultLineInserted === "Y") {
          await fetchReceiptLines(hdNo, receiptDocId);
        }

        setIsNotifyDialogOpen(true);
        setIsProcessing(false);
      }
    } catch (err) {
      setIsProcessing(false);
      console.log(err);
    }
  };


  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const [activeTab, setActiveTab] = useState(0);

  function getMenuTitle(menuKey) {
    switch (menuKey) {
      case 'details':
        return t('details');
      case 'attachments':
        return t('attachments');
      case 'matching':
        return t('matching');
      case 'correspondence':
        return t('correspondence');
      case 'comments':
        return t('comments');
      default:
        return '';
    }
  }

  const topMenus = [
    {
      menu_key: "details",
      menu_title: getMenuTitle("details"),
      menu_icon: <MdEditDocument />,
      menu_count: 0,
    },
    {
      menu_key: "attachments",
      menu_title: getMenuTitle("attachments"),
      menu_icon: <RiAttachment2 />,
      menu_count: attachmentsData.length,
    },
    {
      menu_key: "correspondence",
      menu_title: getMenuTitle("correspondence"),
      menu_icon: <MdSms />,
      menu_count: 0,
    },
    {
      menu_key: "comments",
      menu_title: getMenuTitle("comments"),
      menu_icon: <IoChatbubbles />,
      menu_count: 0,
    },
  ];


  const handleLineInputChange = (e, id, field) => {
    try {
      const newSmiData = [...receiptLines];
      const index = newSmiData.findIndex(smi => smi._id === id);
      if (index !== -1) {
        newSmiData[index][field] = e.target.value;
        newSmiData[index]["changed_xx"] = "Y";
        setReceiptLines(newSmiData);
      }
    } catch (error) {
      console.log(error);
    }
  };



  const handleLineBlur = (id, field) => {
    try {
      const updatedData = [...receiptLines];
      const index = updatedData.findIndex(smi => smi._id === id);

      if (index !== -1) {
        let value = updatedData[index][field];
        const numberFields = ["ln_fc_amount", "ln_doc_amount_fc"];
        let documentAmount = parseFloat(formatStringToNumberV2(updatedData[index]["ln_doc_amount_fc"] || 0));
        // console.log(`field is ${field}`);
        // console.log(`value is ${value}`);
        // console.log(`serviceAmount is ${serviceAmount} and formatted is ${formatStringToNumberV2(value)}`);
        // If the approved amount is greater than the service amount, reset to zero
        if (field === "ln_fc_amount" && parseFloat(formatStringToNumberV2(value)) > documentAmount) {
          updatedData[index]["ln_fc_amount"] = 0;
          setNotifyDialogTitle(t('note'));
          setNotifyDialogText(
            `You cannot match amount greater than the document amount of ${numeral(documentAmount).format("0,0.00")}!`
          );
          setIsNotifyDialogOpen(true);
        } else {
          if (numberFields.includes(field)) {
            updatedData[index][field] = formatAmountsToDecimals(value);
          } else {
            updatedData[index][field] = value;
          }
        }

        setReceiptLines(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleHdTypeChange = (next) => {
    if (next === "Miscellaneous") {
      setHdEntCode(null);
    } else if (next === "Normal") {
      setHdMiscName(null);
      setHdMiscEmail(null);
      setHdMiscPhone(null);
      setHdMiscIdnumber(null);
      setHdMglCode(null);
      setHdSglCode(null);
      setHdMiscTaxPin(null);
      setHdMiscRefNo(null);
    }
    setHdType(next);
  };



  useEffect(() => {
    try {
      fetchEntityPolicies(hdEntCode?.value);
    } catch (error) {
      console.log(error);
    }
  }, [hdEntCode]);


  useEffect(() => {
    try {
      fetchPeriods(hdWhichYear?.value || currentUser?.current_fy_xx);
    } catch (error) {
      console.log(error);
    }
  }, [hdWhichYear?.value]);

  useEffect(() => {
    if (docid) {
      setReceiptDocId(docid);
    }
  }, [docid]);


  useEffect(() => {
    // fetch number generation to check if its auto or manual
    fetchNumberGeneration();

    //if receipt is selected, use receiptDocId to get quote details
    //if its new record, no fetch is necessary

    if (receiptDocId === "new" || receiptDocId === undefined) {
      setReceiptDocId("new");
      setDocumentEnabled("Y");
      // // set gl date
      const currentDate = new Date();
      const formattedCurrentDate = currentDate.toISOString().split("T")[0];
      setHdGlDate(formattedCurrentDate);
      // set defult business unit
      setHdBizUnit({
        value: currentUser?.biz_unit_code_xx,
        label: currentUser?.biz_unit_name_xx,
      });
      // set default currency
      setHdCurCode({
        value: currentUser?.currency_code_xx,
        label: currentUser?.currency_name_xx,
      });

      setHdWhichYear({
        value: currentUser?.current_fy_xx,
        label: currentUser?.current_fy_xx,
      });
      if (clientRef.current) {
        clientRef.current.focus();
      }
    } else {
      fetchReceipt(receiptDocId, true);
    }
    callDetailsFunction();
  }, [receiptDocId]);


  return (
    <motion.div
      className="ar-receipt"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="ar-receipt-main-wrapper" ref={pageShellRef}>
          <div className="ar-receipt-navbar">
            <div className="ar-receipt-navbar-left">
              <span className="page-title"> {hdEntCode?.label || t('newReceipt')}</span>
              <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{`${hdMode?.label} [${hdStatus}]`}</span>
            </div>
            <div className="ar-receipt-navbar-right">

              {receiptDocId !== "new" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0f766e5d"
                  endIcon={<MdRefresh />}
                  onClick={async () => { await fetchReceipt(receiptDocId) }}
                >
                  {t('refresh')}
                </CustomLoadingButton>
              )}
              {receiptDocId !== "new" && nextAction !== "None" && (
                <>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="both"
                    variant="EDE9FE"
                    color="#fbbf24"
                    endIcon={<DragIndicatorIcon />}
                    onClick={() => {
                      try {
                        // console.log(`Status is ${hdStatus}`);
                        let action_text = "";
                        let new_doc_status = hdStatus;
                        switch (hdStatus) {
                          case "New":
                            action_text = `Do you want to Validate ${hdNo}?`;
                            setInvokedAction("Validate");
                            new_doc_status = "Validated";
                            break;
                          case "Validated":
                            action_text = `Do you want to Approve ${hdNo}?`;
                            setInvokedAction("Approve");
                            new_doc_status = "Approved";
                            break;
                          case "Approved":
                            action_text = `Do you want to cancel ${hdNo}?`;
                            setInvokedAction("Cancel");
                            new_doc_status = "Cancelled";
                            break;
                          default:
                            action_text = "";
                            new_doc_status = "";
                        }
                        setObjectToAction({
                          object_id: receiptData._id,
                          action_text: action_text,
                          new_doc_status,
                        });
                        setConfirmDialogAction("receiptAction");
                        setIsConfirmDialogOpen(true);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    {nextAction}
                  </CustomLoadingButton>
                </>
              )}
              {documentEnabled === "Y" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#00D37F"
                  tooltip="Save changes"
                  endIcon={<MdSave />}
                  onClick={saveRecord}>
                  {t('save')}
                </CustomLoadingButton>
              )}
              {receiptDocId !== "new" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#2563EB"
                  tooltip="Run reports for this document"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
              )}
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#f55656"
                tooltip="Close this document"
                endIcon={<MdClose />}
                onClick={() => navigate(-1)}>
                {t('close')}
              </CustomLoadingButton>
              {receiptDocId !== "new" && (
                <div className="collaborator-icon"
                  onClick={openCollab}>
                  <MdForum className="icon" />
                </div>
              )}
            </div>
          </div>
          <div className="content-summary-wrapper">
            <div className="content-wrapper">
              <div className="tabs-container">
                <div className="tab-header">
                  {topMenus?.map((tab, index) => (
                    <div
                      key={index}
                      className={`${activeTab === index ? 'tab active' : 'tab'}`}
                      onClick={() => handleTabClick(index)}
                    >
                      <span className={`${activeTab === index ? 'tab-icon active' : 'tab-icon'}`}>
                        {tab.menu_icon}
                      </span>
                      <span className={`${activeTab === index ? 'tab-title active' : 'tab-title'}`}>{tab.menu_title}</span>
                      {tab.menu_count > 0 && <Badge badgeContent={tab.menu_count} showZero
                        className={activeTab === index ? "tab-badge active" : "tab-badge"} />}
                    </div>
                  ))}
                </div>
              </div>
              <div className="receipt-content-details">
                {/* Summary Information */}
                {activeTab === 0 &&
                  <>
                    {documentEnabled === "N" &&
                      <div className="content-details-row approved-doc">
                        <span>{`${t('receipt').toUpperCase()}: ${hdNo}`}</span>
                        <span>{`${t('bizUnit').toUpperCase()}: ${hdBizUnit?.label}`}</span>
                        <span className={`main-title status ${getCssValue(hdStatus)}`}>{hdStatus}</span>
                      </div>}
                    {/* received from */}

                    <ExpandableComponent
                      title={t('receivedFrom').toUpperCase()}
                      subtitle={
                        <CustomRadioGroup
                          id="hd_type"
                          value={hdType}
                          onChange={handleHdTypeChange}
                          label={hdType}
                          labelPosition="end"
                          labelWidth="max-content"
                          disabled={documentEnabled !== "Y"}
                          options={["Normal", "Miscellaneous"].map((v) => ({ value: v, label: v }))}
                        />
                      }
                      defaultExpanded={true}
                    >
                      <div className="content-details-row client">
                        {hdType === "Normal" ?
                          <motion.div
                            className="entity-details-container"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 1 } }}
                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                            <div className="entity-details-wrapper">
                              <div className="entity-details-left">
                                {hdEntCode?.ent_photo_url ?
                                  <img src={hdEntCode?.ent_photo_url} alt="" className="img" />
                                  :
                                  <InitialsAvatar
                                    name={hdEntCode?.ent_name}
                                    size={60}
                                    currentTheme={currentTheme}
                                  />}
                              </div>
                              <div className="entity-details-right">
                                <div className="name-row">
                                  <div className="input-item-with-label">
                                    <AsyncSelect
                                      ref={clientRef}
                                      id="hd_ent_code"
                                      name="hd_ent_code"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="450px"
                                      value={hdEntCode}
                                      onChange={(selectedOption) => setHdEntCode(selectedOption)}
                                      loadOptions={fetchClientsBySearch}
                                      isSearchable
                                      isDisabled={documentEnabled === "N"}
                                      placeholder={t('client')}
                                      noOptionsMessage={() => customNoOptionsMessage("Type Minimum 3 Letter to Search")}
                                    />
                                  </div>
                                  <span className="sub-title">
                                    {receiptData?.client_details_xx?.ent_type === "Individual" &&
                                      receiptData?.client_details_xx?.ent_occupation_xx &&
                                      <span className="sub-title">{`${t('occupation')} : ${receiptData?.client_details_xx?.ent_occupation_xx}`}</span>
                                    }
                                    {receiptData?.client_details_xx?.ent_type !== "Individual" &&
                                      receiptData?.client_details_xx?.ent_sub_sector_xx &&
                                      <span className="sub-title">{`${t('sector')} : ${receiptData?.client_details_xx?.ent_sector_xx} | ${receiptData?.client_details_xx?.ent_sub_sector_xx}`}</span>
                                    }
                                  </span>
                                </div>
                                <div className="email-phone-row">
                                  <span className="email-phone-details" style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      try {
                                        setEmailData({
                                          to: hdEntCode?.ent_email,
                                          cc: '',
                                          bcc: '',
                                          subject: `RECEIPT NO ${hdNo}`,
                                          show_attach: "Y",
                                          attached_urls: [],
                                          binary_docs: [],
                                          doc_no: hdNo,
                                          doc_type: "Receipt",
                                          doc_id: receiptDocId,
                                          entity_codes: [hdEntCode?.value],
                                          search_string: hdEntCode?.label?.props?.children[0] + "," + hdNo,
                                          carrierName: '',
                                          productName: '',
                                          clientName: hdEntCode?.label?.props?.children[0],
                                          riskNoteNo: hdNo,
                                          daysToRenewal: receiptData?.expiring_in_days,
                                          expiryDate: receiptData?.fmt_to_date,
                                          insuredName: hdEntCode?.label?.props?.children[0],
                                          outstandingPremium: receiptData?.outstandingPremium,
                                          policyCurrency: hdCurCode?.value,
                                          policyNumber: hdNo,
                                          policyPremium: receiptData?.fmt_policy_fc_prem,
                                          policyPremiumTotal: receiptData?.fmt_total_fc_prem,
                                          policySumInsured: receiptData?.fmt_total_fc_si,
                                          policyFromDate: receiptData?.fmt_fm_date,
                                          policyToDate: receiptData?.fmt_to_date,
                                          tpt_category: []
                                        });
                                        setEmailDialogOpen(true);
                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }}>
                                    <MdAlternateEmail className="icon" /> <h1 className="sub-title">{hdEntCode?.ent_email || "Unspecified"}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <MdPhone className="icon" /> <h1 className="sub-title">{hdEntCode?.ent_phone_no || "Unspecified"}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <TbCertificate className="icon" /> <h1 className="sub-title">{hdEntCode?.aent_name_xx || ""}</h1>
                                  </span>
                                  <span className="email-phone-details"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate(`/entity/${receiptData?.client_details_xx?._id}`)}>
                                    <TagIcon className="icon" /> <h1 className="sub-title">{hdEntCode?.ent_code}</h1>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </motion.div>
                          :
                          <motion.div
                            className="misc-container"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 1 } }}
                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                            <div className="misc-row">
                              <div className="misc-row-avatar">
                                <InitialsAvatar
                                  name={hdMiscName}
                                  size={60}
                                  currentTheme={currentTheme}
                                />
                              </div>
                              <div className="misc-row-left">
                                <div className="input-item-with-label">
                                  <input
                                    ref={miscNameRef}
                                    id="hd_misc_name"
                                    name="hd_misc_name"
                                    type="text"
                                    placeholder={t('fullName').toUpperCase()}
                                    value={hdMiscName}
                                    className="form-input-item"
                                    style={{ width: "450px" }}
                                    onChange={(e) => setHdMiscName(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                                <div className="input-item-with-label">
                                  <input
                                    id="hd_misc_email"
                                    name="hd_misc_email"
                                    type="email"
                                    placeholder={t('email').toUpperCase()}
                                    value={hdMiscEmail}
                                    className="form-input-item"
                                    style={{ width: "450px" }}
                                    onChange={(e) => setHdMiscEmail(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                              </div>
                              <div className="misc-row-right">
                                <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                                  <label htmlFor="hd_misc_phone" className="form-dropdown-label">{t('phoneNo').toUpperCase()}</label>
                                  <input
                                    id="hd_misc_phone"
                                    name="hd_misc_phone"
                                    type="text"
                                    placeholder={t('phoneNo').toUpperCase()}
                                    value={hdMiscPhone}
                                    className="form-input-item"
                                    style={{ width: "200px" }}
                                    onChange={(e) => setHdMiscPhone(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                                <div className="input-item-with-label">
                                  <label htmlFor="hd_misc_idnumber" className="form-dropdown-label">{t('idNumber').toUpperCase()}</label>
                                  <input
                                    id="hd_misc_idnumber"
                                    name="hd_misc_idnumber"
                                    type="text"
                                    placeholder={t('idNumber').toUpperCase()}
                                    value={hdMiscIdnumber}
                                    className="form-input-item"
                                    style={{ width: "200px" }}
                                    onChange={(e) => setHdMiscIdnumber(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="misc-row">
                              <div className="misc-row-left">
                                <div className="input-item-with-label">
                                  <label htmlFor="hd_mgl_code" className="form-dropdown-label" style={{ width: "100px" }}>{t('main').toUpperCase()}</label>
                                  <AsyncSelect
                                    id="hd_mgl_code"
                                    name="hd_mgl_code"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="450px"
                                    value={hdMglCode}
                                    onChange={(selectedOption) => {
                                      try {
                                        setHdMglCode(selectedOption);
                                        setHdMglSubType(selectedOption?.ma_sub_type);
                                        setHdSglCode(null);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    loadOptions={(inputValue, callback) => fetchMainLedgers(inputValue, callback, [])}
                                    isSearchable
                                    isClearable
                                    isDisabled={documentEnabled === "N"}
                                    placeholder={t('main')}
                                    noOptionsMessage={() => t('typeToSearch', { param1: 2 })} />
                                </div>
                                {<div className="input-item-with-label">
                                  <label htmlFor="hd_sgl_code" className="form-dropdown-label" style={{ width: "100px" }}>{t('sub').toUpperCase()}</label>
                                  {hdMglSubType === "Account" ?
                                    <AsyncSelect
                                      id="hd_sgl_code"
                                      name="hd_sgl_code"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="450px"
                                      value={hdSglCode}
                                      onChange={(selectedOption) => setHdSglCode(selectedOption)}
                                      loadOptions={(inputValue, callback) => fetchSubLedgers(inputValue, callback, hdMglCode?.value)}
                                      isSearchable
                                      isClearable
                                      isDisabled={documentEnabled === "N"}
                                      placeholder={t('sub')}
                                      noOptionsMessage={() => t('typeToSearch', { param1: 2 })} />
                                    :
                                    <AsyncSelect
                                      id="misc_ent_code"
                                      name="misc_ent_code"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="450px"
                                      value={hdSglCode}
                                      onChange={(selectedOption) => setHdSglCode(selectedOption)}
                                      loadOptions={fetchClientsBySearch}
                                      isSearchable
                                      isClearable
                                      isDisabled={documentEnabled === "N"}
                                      placeholder={t('entity').toUpperCase()}
                                      noOptionsMessage={() => customNoOptionsMessage(t('typeToSearch', { param1: 2 }))}
                                    />}

                                </div>}
                              </div>
                              <div className="misc-row-right">
                                <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                                  <label htmlFor="hd_misc_tax_pin" className="form-dropdown-label">{t('taxPin').toUpperCase()}</label>
                                  <input
                                    id="hd_misc_tax_pin"
                                    name="hd_misc_tax_pin"
                                    type="text"
                                    placeholder={t('taxPin').toUpperCase()}
                                    value={hdMiscTaxPin}
                                    className="form-input-item"
                                    style={{ width: "200px" }}
                                    onChange={(e) => setHdMiscTaxPin(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                                <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                                  <label htmlFor="hd_misc_ref_no" className="form-dropdown-label">{t('refNo').toUpperCase()}</label>
                                  <input
                                    id="hd_misc_ref_no"
                                    name="hd_misc_ref_no"
                                    type="text"
                                    placeholder={t('refNo').toUpperCase()}
                                    value={hdMiscRefNo}
                                    className="form-input-item"
                                    style={{ width: "200px" }}
                                    onChange={(e) => setHdMiscRefNo(e.target.value)}
                                    disabled={documentEnabled === "N"}
                                  />
                                </div>
                              </div>
                            </div>
                          </motion.div>}
                      </div>
                    </ExpandableComponent>
                    {/* end of received from  */}

                    {/* receipt details */}
                    <ExpandableComponent
                      title={t('details').toUpperCase()}
                      subtitle={<span className={`status ${hdStatus}`}>{`${t('status').toUpperCase()} ${hdStatus}`}</span>}
                      defaultExpanded={true}
                    >
                      <div className="content-details-row">
                        <div className="content-details-left">
                          <div className="input-item-with-label">
                            <label htmlFor="hd_ac_no" className="form-dropdown-label" style={{ width: "100px" }}>{t('depositTo').toUpperCase()}</label>
                            <Select
                              id="hd_ac_no"
                              name="hd_ac_no"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="450px"
                              value={hdAcNo}
                              onChange={(selectedOption) => setHdAcNo(selectedOption)}
                              options={bankAccounts}
                              isSearchable
                              isDisabled={documentEnabled === "N"}
                              placeholder={t('depositTo').toUpperCase()}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_biz_unit"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('bizUnit').toUpperCase()}
                              </label>
                              <Select
                                id="hd_biz_unit"
                                name="hd_biz_unit"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark"
                                    ? customSelectStyles_dark
                                    : customSelectStyles_light),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                width="170px"
                                value={hdBizUnit}
                                onChange={(selectedOption) => setHdBizUnit(selectedOption)}
                                options={branches}
                                isSearchable
                                isDisabled={documentEnabled === "N"}
                                placeholder={t('bizUnit').toUpperCase()}
                              />
                            </div>
                            <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                              <label
                                htmlFor="hd_ref_no"
                                className="form-dropdown-label"
                              >
                                {t('refNo').toUpperCase()}
                              </label>
                              <input
                                id="hd_ref_no"
                                name="hd_ref_no"
                                type="text"
                                placeholder={t('refNo').toUpperCase()}
                                value={hdRefNo}
                                className="form-input-item"
                                style={{ width: "170px" }}
                                onChange={(e) => setHdRefNo(e.target.value)}
                                disabled={documentEnabled === "N"}
                              />
                            </div>
                          </div>
                          <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "start",
                            justifyContent: "space-between",
                            width: "100%",
                          }}>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_mode"
                                className="form-dropdown-label" style={{ width: "100px" }}
                              >
                                {t('mode').toUpperCase()}
                              </label>
                              <Select
                                id="hd_mode"
                                name="hd_mode"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="170px"
                                value={hdMode}
                                onChange={(selectedOption) => setHdMode(selectedOption)}
                                options={receiptMode}
                                isSearchable
                                placeholder={t('mode').toUpperCase()}
                                isDisabled={documentEnabled === "N"}
                              />
                            </div>
                            <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                              <label
                                htmlFor="hd_chq_no"
                                className="form-dropdown-label"
                              >
                                {t('chqNo').toUpperCase()}
                              </label>
                              <input
                                id="hd_chq_no"
                                name="hd_chq_no"
                                type="text"
                                placeholder={t('chqNo').toUpperCase()}
                                disabled={documentEnabled === "N"}
                                value={hdChqNo}
                                className="form-input-item"
                                style={{ width: "170px" }}
                                onChange={(e) => setHdChqNo(e.target.value)}
                              />
                            </div>
                          </div>
                          <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "start",
                            justifyContent: "space-between",
                            width: "100%",
                          }}>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="hd_paying_for"
                                className="form-dropdown-label" style={{ width: "100px" }}
                              >
                                {t('purpose').toUpperCase()}
                              </label>
                              <Select
                                ref={payingForRef}
                                id="hd_paying_for"
                                name="hd_paying_for"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="170px"
                                value={hdPayingFor}
                                onChange={(selectedOption) => setHdPayingFor(selectedOption)}
                                options={payingFor}
                                isSearchable
                                placeholder={t('payingFor').toUpperCase()}
                                isDisabled={documentEnabled === "N"}
                              />
                            </div>
                            <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                              <label
                                htmlFor="hd_chq_date"
                                className="form-dropdown-label"
                              >
                                {t('chqDate').toUpperCase()}
                              </label>
                              <input
                                id="hd_chq_date"
                                name="hd_chq_date"
                                type="date"
                                placeholder={t('chqDate').toUpperCase()}
                                value={hdChqDate}
                                className="form-input-item"
                                style={{ width: "170px" }}
                                onChange={(e) => {
                                  try {
                                    const formattedChqDate = moment(
                                      e.target.value
                                    ).format("YYYY-MM-DD");
                                    setHdChqDate(formattedChqDate);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                disabled={documentEnabled === "N"}
                              />
                            </div>
                          </div>
                          {/* for SHIF receipting */}
                          {["SHIF Corporate", "SHIF Individual"].includes(hdPayingFor?.value) &&
                            <div style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "start",
                              justifyContent: "space-between",
                              width: "100%",
                            }}>
                              <div className="input-item-with-label">
                                <label
                                  htmlFor="hd_which_year"
                                  className="form-dropdown-label" style={{ width: "80px" }}
                                >
                                  {t('year').toUpperCase()}
                                </label>
                                <Select
                                  id="hd_which_year"
                                  name="hd_which_year"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="170px"
                                  value={hdWhichYear}
                                  onChange={(selectedOption) => setHdWhichYear(selectedOption)}
                                  options={payingYears}
                                  isSearchable
                                  placeholder={t('year').toUpperCase()}
                                  isDisabled={documentEnabled === "N"}
                                />
                              </div>
                              <div className="input-item-with-label">
                                <label
                                  htmlFor="hd_which_period"
                                  className="form-dropdown-label" style={{ width: "80px" }}
                                >
                                  {t('period').toUpperCase()}
                                </label>
                                <Select
                                  id="hd_which_period"
                                  name="hd_which_period"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="170px"
                                  value={hdWhichPeriod}
                                  onChange={(selectedOption) => setHdWhichPeriod(selectedOption)}
                                  options={payingPeriods}
                                  isSearchable
                                  placeholder={t('period').toUpperCase()}
                                  isDisabled={documentEnabled === "N"}
                                />
                              </div>
                            </div>}
                        </div>
                        <div className="content-details-right">
                          <div className="input-item-with-label">
                            <label htmlFor="hd_no" className="form-dropdown-label">
                              {t('receiptNo').toUpperCase()}
                            </label>
                            <input
                              id="hd_no"
                              name="hd_no"
                              type="text"
                              placeholder={t('receiptNo').toUpperCase()}
                              value={hdNo}
                              disabled={!isDocumentNumberSetup}
                              className="form-input-item"
                              style={{ width: "200px" }}
                              onChange={(e) => setHdNo(e.target.value)}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="hd_gl_date"
                              className="form-dropdown-label"
                            >
                              {t('glDate').toUpperCase()}
                            </label>
                            <input
                              ref={glDateRef}
                              id="hd_gl_date"
                              name="hd_gl_date"
                              type="date"
                              placeholder={t('glDate').toUpperCase()}
                              value={hdGlDate}
                              className="form-input-item"
                              style={{ width: "200px" }}
                              onChange={handleGlDateChange}
                              disabled={documentEnabled === "N"}
                            />
                          </div>
                          <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                            <label
                              htmlFor="hd_cur_code"
                              className="form-dropdown-label"
                              style={{ width: "80px" }}
                            >
                              {t('currency').toUpperCase()}
                            </label>
                            <Select
                              id="hd_cur_code"
                              name="hd_cur_code"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark"
                                  ? customSelectStyles_dark
                                  : customSelectStyles_light),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              width="200px"
                              value={hdCurCode}
                              onChange={async (selectedOption) => {
                                try {
                                  if (selectedOption.value !== currentUser?.currency_code_xx) {
                                    setHdCurCode(selectedOption);

                                    const res = await newRequest.post("/glCurrencyRate/find", {
                                      rate_cur_code_fm: selectedOption.value,
                                      rate_cur_code_to: currentUser?.currency_code_xx,
                                      rate_date: hdGlDate,
                                    });
                                    if (!res.data || !res.data?.rate) {
                                      setHdCurCode({
                                        value: currentUser.currency_code_xx,
                                        label: currentUser.currency_name_xx,
                                      });
                                      setHdCurRate(1);
                                      setNotifyDialogTitle(t('note'));
                                      setNotifyDialogText(
                                        `Conversion Rate from <strong>${selectedOption.value
                                        } to ${currentUser.currency_code_xx
                                        } for date ${moment(hdGlDate).format(
                                          "DD-MMM-YYYY"
                                        )}</strong> NOT found. Currency will reset to <strong>${currentUser.currency_code_xx
                                        }</strong>`
                                      );
                                      setIsNotifyDialogOpen(true);
                                    } else {
                                      setHdCurRate(res.data.rate);
                                    }
                                  } else {
                                    setHdCurCode({
                                      value: currentUser?.currency_code_xx,
                                      label: currentUser?.currency_name_xx,
                                    });
                                    setHdCurRate(1);
                                    const lcAmount = Number(parseFloat(formatStringToNumberV2(hdFcAmount)).toFixed(4));
                                    setHdLcAmount(lcAmount);
                                  }
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              options={currencies}
                              isSearchable
                              isDisabled={documentEnabled === "N"}
                              placeholder={t('currency').toUpperCase()}
                            />
                          </div>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="hd_fc_amount"
                              className="form-dropdown-label"
                            >
                              {t('amount').toUpperCase()}
                            </label>
                            <input
                              id="hd_fc_amount"
                              name="hd_fc_amount"
                              type="text"
                              placeholder="0.00"
                              value={hdFcAmount}
                              className="form-input-item"
                              style={{ width: "200px", textAlign: "right", fontWeight: "bold" }}
                              onChange={(e) => setHdFcAmount(e.target.value)}
                              disabled={documentEnabled === "N"}
                              onBlur={handleFcAmountBlur}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="content-details-row" style={{ marginTop: "15px" }}>
                        <div className="input-item-with-label"
                          style={{
                            display: "flex",
                            width: "100%",
                          }}>
                          <label
                            htmlFor="hd_narration"
                            className="form-dropdown-label"
                            style={{ width: "115px", alignSelf: "flex-start" }}
                          >
                            {t('narration').toUpperCase()}
                          </label>
                          <textarea
                            id="hd_narration"
                            name="hd_narration"
                            type="text"
                            placeholder={t('narration').toUpperCase()}
                            value={hdNarration}
                            row={5}
                            className="form-input-item"
                            style={{ width: "100%" }}
                            onChange={(e) => setHdNarration(e.target.value)}
                            disabled={documentEnabled === "N"}
                          />
                        </div>
                      </div>
                    </ExpandableComponent>
                    {/* end if receipt details */}
                    {/* receipt lines */}
                    <ExpandableComponent
                      title={t('matchedRecords').toUpperCase()}
                      subtitle={
                        hdPayingFor?.value === "Investment" &&
                        documentEnabled === "Y" &&
                        receiptDocId !== "new" &&
                        <div className="inline-buttons-wrapper">
                          {/* THIS IS FOR INVESTMENT MATCH TO THE RECEIPTING ENTITY */}
                          <span style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                            <AsyncSelect
                              ref={investorRef}
                              id="investor"
                              name="investor"
                              menuPortalTarget={document.body}
                              styles={{
                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                menuPortal: base => ({
                                  ...base,
                                  zIndex: 9999,
                                })
                              }}
                              width="300px"
                              value={selectedInvestor}
                              onChange={(selectedOption) => setSelectedInvestor(selectedOption)}
                              loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                              isSearchable
                              placeholder={t('investor')}
                              noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                            />
                            <CircularButton
                              currentTheme={currentTheme}
                              onClick={async (e) => {
                                try {

                                  if (!selectedInvestor) {
                                    setNotifyDialogTitle(t('note'));
                                    setNotifyDialogText(`Please select account`);
                                    setIsNotifyDialogOpen(true);
                                    return;
                                  }

                                  const checkExists = receiptLines.filter((line) => line.ln_ent_code === selectedInvestor?.ent_code);

                                  if (checkExists) {
                                    setNotifyDialogTitle(t('note'));
                                    setNotifyDialogText(`${selectedInvestor?.ent_name} is already added`);
                                    setIsNotifyDialogOpen(true);
                                    return;
                                  }

                                  // console.log(`addArReceiptLine  ${JSON.stringify(selectedPolicy, null, 2)}`);
                                  const res = await newRequest.post("/arReceiptLn/add", {
                                    ln_hd_no: hdNo,
                                    ln_hd_no_docid: receiptData?._id,
                                    ln_doc_type: selectedPolicy?.pl_type,
                                    ln_doc_no: selectedPolicy?.pl_risk_note_no,
                                    ln_doc_docid: selectedPolicy?.pl_docid,
                                    ln_hd_status: hdStatus,
                                    ln_paying_for: hdPayingFor?.value,
                                    ln_doc_ins_no: selectedInstallment?.value,
                                    ln_fc_amount: 0,
                                    ln_lc_amount: 0,
                                    ln_doc_amount_fc: 0,
                                    ln_doc_amount_lc: 0,
                                    ln_ent_code: hdEntCode?.value,
                                    ln_comm_fc: 0,
                                    ln_comm_lc: 0,
                                    ln_narration: "Matched",
                                    ln_insured_ent_code: selectedPolicy?.pl_assr_ent_code,
                                    ln_carrier_ent_code: selectedPolicy?.pl_ins_ent_code,
                                  });

                                  if (res.data?.msg === "added") {
                                    setReceiptLines((prevData) => [...prevData, {
                                      ...res.data?.doc,
                                      ln_fc_amount: formatAmountsToDecimals(res.data?.doc?.ln_fc_amount || 0),
                                      ln_lc_amount: formatAmountsToDecimals(res.data?.doc?.ln_lc_amount || 0),
                                    }]);
                                    setSelectedInvestor(null);
                                    if (investorRef.current) {
                                      investorRef.current.focus();
                                    }
                                    showToast(`Added`, "success");
                                  } else if (res.data?.msg === "exists") {
                                    setSelectedInvestor(null);
                                    showToast(`Already added`, "success");
                                  } else {
                                    showToast(res.data?.msg, "error");
                                  }
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                              icon={<MdAdd />}
                              width={"35px"}
                              height={"35px"} />
                          </span>
                        </div>}
                      defaultExpanded={true}
                    >
                      <div className="lines-wrapper">
                        {receiptDocId === "new" && (
                          <motion.div className="doc-not-saved"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 1 } }}
                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                            NEW RECEIPT. AFTER SAVING, YOU'LL BE ABLE TO PERFORM MORE ACTIONS
                          </motion.div>
                        )}
                        {receiptDocId !== "new" &&
                          !["Cancelled", "Voided"].includes(hdStatus) &&
                          (
                            <>
                              {/* THIS IS FOR PREMIUM PAYMENTS. SHOW INSTALMENTS FROM UNDEWRITING */}
                              {hdPayingFor?.value === "Premium" &&
                                !["Cancelled"].includes(hdStatus) &&
                                (formatStringToNumberV2(hdFcAmount) - allocatedFcAmountXx) > 0 &&
                                <div className="inline-buttons-wrapper">
                                  <label
                                    htmlFor="rn"
                                    className="form-dropdown-label"
                                    style={{ width: "max-content" }}
                                  >
                                    {t('doc').toUpperCase()}
                                  </label>
                                  {/* policy */}
                                  <Select
                                    id="rn"
                                    name="rn"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                      menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999,
                                      })
                                    }}
                                    width="250px"
                                    value={selectedPolicy}
                                    onChange={async (selectedOption) => {
                                      try {
                                        // console.log(`selectedOption  ${JSON.stringify(selectedOption, null, 2)}`);
                                        setSelectedPolicy(selectedOption);
                                        setInstallments(null);
                                        setSelectedInstallment(null);

                                        setMatchedFcAmount(formatNumber(0, 2));
                                        setMatchedLcAmount(formatNumber(0, 2));
                                        // maximum amount that can be matched
                                        setMaxMatchFcAmount(0);
                                        setMaxMatchLcAmount(0);

                                        await fetchPolicyInstallments(selectedOption.pl_docid);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}
                                    options={entityPolicies}
                                    isSearchable
                                    placeholder={t('doc').toUpperCase()}
                                  />
                                  {/* installment */}
                                  <div className="input-item-with-label">
                                    <label
                                      htmlFor="ins"
                                      className="form-dropdown-label"
                                      style={{ width: "max-content" }}
                                    >
                                      {t('ins').toUpperCase()}
                                    </label>
                                    <Select
                                      id="ins"
                                      name="ins"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999,
                                        })
                                      }}
                                      width="150px"
                                      dropdownHeight={4 * 42}
                                      value={selectedInstallment}
                                      onChange={(selectedOption) => {
                                        try {
                                          // console.log(`selectedOption  ${JSON.stringify(selectedOption, null, 2)}`);
                                          setSelectedInstallment(selectedOption);
                                          setMatchedFcAmount(formatNumber(selectedOption?.os_fc_amount_xx, 2));
                                          setMatchedLcAmount(formatNumber(selectedOption?.os_lc_amount_xx, 2));

                                          // maximum amount that can be matched
                                          setMaxMatchFcAmount(selectedOption?.os_fc_amount_xx);
                                          setMaxMatchLcAmount(selectedOption?.os_lc_amount_xx);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                      options={installments}
                                      isSearchable
                                      placeholder={t('ins').toUpperCase()}
                                    />
                                  </div>
                                  <div className="input-item-with-label">
                                    <label
                                      htmlFor="matched_fc_amount"
                                      className="form-dropdown-label"
                                      style={{ width: "80px" }}
                                    >
                                      {t('amount').toUpperCase()}
                                    </label>
                                    <input
                                      id="matched_fc_amount"
                                      name="matched_fc_amount"
                                      type="text"
                                      placeholder="0.00"
                                      value={matchedFcAmount}
                                      className="form-input-item"
                                      style={{ width: "120px", textAlign: "right" }}
                                      onChange={(e) => setMatchedFcAmount(e.target.value)}
                                      onBlur={handleMatchedFcAmountBlur}
                                    />
                                  </div>
                                  <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#0ea5a4"
                                    tooltip={selectedPolicy?.pl_risk_note_no ? `Match ${selectedPolicy?.pl_risk_note_no || ""} to this payment` : `Select document to add`}
                                    endIcon={<MdAdd />}
                                    onClick={handleAddMatchingDoc}
                                  >
                                    {t('add')}
                                  </CustomLoadingButton>
                                </div>}
                              <motion.div
                                className="table-content"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1, transition: { duration: 1 } }}
                                exit={{ opacity: 0, transition: { duration: 1 } }}>
                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                  <Table sx={{ width: "max-content", border: 'none' }}>
                                    <TableHead className="tablehead">
                                      <TableRow className="tablerow">
                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                          #
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                          <span> {t('type').toUpperCase()}</span>
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                          {/* FOR INSURANCE, BROKER, AGENT */}
                                          {!["SHIF Corporate", "SHIF Individual", "Investment"].includes(hdPayingFor?.value) &&
                                            <span> {t('document').toUpperCase()}</span>}
                                          {/* FOR REGULATOR */}
                                          {["SHIF Corporate", "SHIF Individual"].includes(hdPayingFor?.value) &&
                                            <span> {t('member').toUpperCase()}</span>}
                                          {/* FOR INVESTMENT */}
                                          {["Investment"].includes(hdPayingFor?.value) &&
                                            <span> {t('investor').toUpperCase()}</span>}
                                        </TableCell>

                                        {/* {!["SHIF Corporate", "SHIF Individual", "Investment"].includes(hdPayingFor?.value) &&
                                          <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                            <span> {t('document').toUpperCase()}</span>
                                          </TableCell>} */}
                                        <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                          <span> {t('allocated').toUpperCase()}</span>
                                        </TableCell>
                                        {currentUser?.currency_code_xx !== hdCurCode?.value &&
                                          <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                            <span>{t('allocatedBase').toUpperCase()}</span>
                                          </TableCell>}
                                        {documentEnabled === "Y" &&
                                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                            <span> {t('action').toUpperCase()}</span>
                                          </TableCell>}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody className="tablebody">
                                      {slicedReceiptLines?.map((row, index) => (
                                        <TableRow
                                          key={row._id}
                                          className={`${selectedReceiptLine?._id === row._id ? "tablerow current" : "tablerow"}`}
                                          onClick={() => setSelectedReceiptLine(row)}
                                        >
                                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            <span className="sub-title">{currentPage * rowsPerPage + index + 1}</span>
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                                            <span className="sub-title">{row.ln_doc_type}</span>
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            {/* FOR INSURANCE, BROKER, AGENT */}
                                            {!["SHIF Corporate", "SHIF Individual", "Investment"].includes(hdPayingFor?.value) &&
                                              <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                                  <span className="sub-title">{row?.ln_doc_no}</span>
                                                  <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{row?.sub_narration_xx}</span>
                                                </div>
                                                <span className="sub-title">{row.main_narration_xx}</span>
                                              </div>}
                                            {/* FOR REGULATOR */}
                                            {["SHIF Corporate", "SHIF Individual"].includes(hdPayingFor?.value) &&
                                              <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                <h1 className='normal-title'>{row?.entity_details_xx?.ent_name} - {row?.entity_details_xx?.ent_phone}</h1>
                                                <span className="sub-title soft xrsmall">{row?.entity_details_xx?.ent_code} - {row?.entity_details_xx?.ent_email}</span>
                                              </div>}

                                            {/* FOR INVESTMENT */}
                                            {["Investment"].includes(hdPayingFor?.value) &&
                                              <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                <h1 className='normal-title'>{row?.entity_details_xx?.ent_name} - {row?.entity_details_xx?.ent_phone}</h1>
                                                <span className="sub-title soft xrsmall">{row?.entity_details_xx?.ent_code} - {row?.entity_details_xx?.ent_email}</span>
                                              </div>}

                                          </TableCell>
                                          {/* {!["SHIF Corporate", "SHIF Individual", "Investment"].includes(hdPayingFor?.value) &&
                                            <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                              <span className="sub-title">{numeral(row.ln_doc_amount_fc).format("0,0.00")}</span>
                                            </TableCell>} */}
                                          <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                            {documentEnabled === "Y" ?
                                              <div className="input-item-with-label">
                                                <input
                                                  id="ln_fc_amount"
                                                  name="ln_fc_amount"
                                                  value={row.ln_fc_amount}
                                                  onChange={(e) => handleLineInputChange(e, row._id, 'ln_fc_amount')}
                                                  onBlur={() => handleLineBlur(row._id, "ln_fc_amount")}
                                                  style={{ width: "100%", textAlign: "right" }}
                                                  className="form-input-item table"
                                                />
                                              </div>
                                              : <h1 className='normal-title'>{numeral(row.ln_fc_amount).format("0,0.00")}</h1>}
                                          </TableCell>

                                          {currentUser?.currency_code_xx !== hdCurCode?.value &&
                                            <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                              <span>{numeral(row.ln_lc_amount).format("0,0.00")}</span>
                                            </TableCell>}

                                          {documentEnabled === "Y" &&
                                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                              <CircularButton
                                                currentTheme={currentTheme}
                                                onClick={() => {
                                                  try {
                                                    setObjectToAction({
                                                      object_id: row._id,
                                                      action_text: `Unmatch ${row.ln_doc_no} from this payment?`,
                                                      new_doc_status: "unmatch",
                                                    });
                                                    setConfirmDialogAction("unmatchDocument");
                                                    setIsConfirmDialogOpen(true);
                                                  } catch (error) {
                                                    console.log(error);
                                                  }
                                                }}
                                                color="#E53935"
                                                icon={<MdDelete />}
                                                width={"30px"}
                                                height={"30px"} />
                                            </TableCell>}
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                  {receiptLines?.length > rowsPerPage &&
                                    <TablePagination
                                      rowsPerPageOptions={[5]}
                                      rowsPerPage={rowsPerPage}
                                      onRowsPerPageChange={handleRowsPerPage}
                                      component="div"
                                      count={receiptLines?.length}
                                      rows={receiptLines}
                                      page={currentPage}
                                      onPageChange={handlePageChange}
                                    />}
                                </TableContainer>
                              </motion.div>
                            </>
                          )}
                      </div>
                    </ExpandableComponent>
                    {/* end of receipt lines */}
                    {/* T-Account after posting document */}
                    {["Approved", "Cancelled"].includes(hdStatus) &&
                      <Taccount key={hdStatus} originalDocId={receiptDocId} originalDocno={hdNo} originalDocType={"AR Receipt"} endorsementIndex={0} />}
                  </>
                }
                {activeTab === 1 && <>
                  <motion.div
                    className="tabs-view-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="attachment">
                      <FileUploadComponent
                        documentNo={hdNo}
                        documentId={receiptDocId}
                        documentType="AR Receipt"
                        fetchDocumentAttachments={fetchDocumentAttachments}
                        uploadFolder={`ar-receipt/${receiptDocId}`} />
                      <div className="attachment-files">
                        <AllFiles filesList={attachmentsData} />
                      </div>
                    </div>
                  </motion.div>
                </>}
                {activeTab === 2 &&
                  <motion.div
                    className="correspondence"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                  >
                    <Correspondence
                      correspondenceParams={{ fetch_type: "document", doc_id: receiptDocId, doc_no: hdNo, doc_type: "Receipt", entity_codes: [hdEntCode?.value] }}
                      passedEmailData={{
                        to: `${receiptData?.client_email_xx}`,
                        cc: `${currentUser?.usr_email}`,
                        bcc: '',
                        subject: `Receipt No ${hdNo}`,
                        show_attach: "Y",
                        attached_urls: [],
                        binary_docs: [],
                        doc_no: hdNo,
                        doc_type: "Receipt",
                        doc_id: receiptDocId,
                        entity_codes: [hdEntCode?.value],
                        search_string: hdEntCode?.label?.props?.children[0] + "," + hdNo,
                        carrierName: "",
                        productName: "",
                        clientName: hdEntCode?.label?.props?.children[0],
                        riskNoteNo: hdNo,
                        daysToRenewal: 0,
                        expiryDate: "",
                        insuredName: hdEntCode?.label?.props?.children[0],
                        outstandingPremium: 0,
                        policyCurrency: hdCurCode?.value,
                        policyNumber: hdNo,
                        policyPremium: "",
                        policyPremiumTotal: "",
                        policySumInsured: "",
                        policyFromDate: "",
                        policyToDate: "",
                        tpt_category: []
                      }} />
                  </motion.div>}
                {activeTab === 3 &&
                  <AllDocsNote
                    docId={receiptData._id}
                    docType="Receipt"
                    noteType={"Normal"}
                  />
                }
              </div>
            </div>
            <div className="receipt-summary-wrapper">
              {receiptDocId !== "new" &&
                hdStatus === "New" &&
                <div className="panel-card void"
                  onClick={() => {
                    try {
                      setObjectToAction({
                        object_id: receiptData._id,
                        action_text: `Do you want to Void ${hdNo}?<br/><br/>${t('thisActionIsIrrevasible')}`
                      });
                      setConfirmDialogAction("voidReceipt");
                      setIsConfirmDialogOpen(true);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <div className="panel-card__header">
                    <div className="panel-card__titleRow">
                      <h1 className="panel-card__title">{t("voidReceipt").toUpperCase()}</h1>
                    </div>
                    <div className="panel-card__body">
                      <div className="kv-row">
                        <span className="kv-key">{t("voidReceiptDesc").toUpperCase()}</span>
                      </div>
                    </div>
                  </div>
                </div>}
              <div className="panel-card" style={{ padding: "10px" }}>
                <WorkedOnBy name={receiptData?.updated_by_name_xx || currentUser?.usr_full_name} photoUrl={receiptData?.updated_by_photo_url_xx} time_ago_xx={receiptData?.time_ago_xx} />
              </div>
              <div className="summary-content">
                {hdCurCode?.value !== currentUser?.currency_code_xx && (
                  <div
                    className="input-item-with-label"
                    style={{ alignSelf: "flex-end", margin: "0px 5px 5px 0px" }}
                  >
                    <label
                      htmlFor="hd_cur_rate"
                      className="form-dropdown-label"
                    >
                      {t('rate').toUpperCase()}
                    </label>
                    <input
                      id="hd_cur_rate"
                      name="hd_cur_rate"
                      type="number"
                      placeholder="0.00"
                      value={hdCurRate}
                      className="form-input-item"
                      style={{
                        width: "150px",
                        textAlign: "right",
                      }}
                      onChange={(e) => setHdCurRate(e.target.value)}
                      disabled={documentEnabled === "N"}
                      onBlur={handleCurRateBlur}
                    />
                  </div>
                )}
                <motion.div
                  className="summary-view"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                  {/* ===================== SUMMARY CARD ===================== */}
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("summary").toUpperCase()}</h1>

                        {currentUser?.currency_code_xx !== hdCurCode?.value && (
                          <CustomButtonSmall
                            style={{ display: "flex" }}
                            onClick={() => setFiguresToShow((p) => (p === "org" ? "base" : "org"))}
                          >
                            {figuresToShow === "org"
                              ? `${t('view')} ${currentUser?.currency_code_xx}`
                              : `${t('view')} ${hdCurCode?.value}`}
                          </CustomButtonSmall>
                        )}

                        <span className="panel-card__currency">
                          {figuresToShow === "org" ? hdCurCode?.value : currentUser?.currency_code_xx}
                        </span>
                      </div>
                      <div className="panel-card__divider" />
                    </div>

                    <div className="panel-card__body">
                      <div className="kv-row">
                        <span className="kv-key">{t("receiptAmount").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? hdFcAmount
                              : hdLcAmount
                          ).format("0,0.00")}
                        </span>
                      </div>
                      <div className="kv-row">
                        {figuresToShow === "org" &&
                          hdFcAmount && (
                            <span className="amount-to-words">{`${hdCurCode?.value
                              } ${numberToWordsWithDecimal(hdFcAmount)}`}</span>
                          )}
                        {figuresToShow !== "org" &&
                          hdLcAmount && (
                            <span className="amount-to-words">{`${currentUser?.currency_code_xx
                              } ${numberToWordsWithDecimal(hdLcAmount)}`}</span>
                          )}
                      </div>
                      <div className="kv-row">
                        <span className="kv-key">{t("allocated").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? allocatedFcAmountXx
                              : allocatedLcAmountXx
                          ).format("0,0.00")}
                        </span>
                      </div>

                      <div className="kv-row">
                        <span className="kv-key">{t("osToAllocate").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(
                            figuresToShow === "org"
                              ? formatStringToNumberV2(hdFcAmount) - allocatedFcAmountXx
                              : hdLcAmount - allocatedLcAmountXx
                          ).format("0,0.00")}
                        </span>
                      </div>

                      {/* TOTAL PREMIUM pill (moved from inline styles to SCSS) */}
                      {/* <div className="pill-row pill-row--success">
                        <span className="pill-label">{t("totalPremium").toUpperCase()}</span>
                        <span className="pill-value">
                          {numeral(
                            figuresToShow === "org"
                              ? hdFcAmount
                              : hdLcAmount
                          ).format("0,0.00")}
                        </span>
                      </div> */}
                    </div>
                  </div>
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("timeline").toUpperCase()}</h1>
                      </div>
                      {/* <div className="panel-card__divider" /> */}
                      <div className="timeline-root">
                        {traceData.map((item) => (
                          <div key={item?._id} className="timeline-item">
                            <div className="timeline-separator">
                              <div className="timeline-dot"></div>
                              <div className="timeline-connector" />
                            </div>
                            <div className="timeline-content">
                              <div className="timeline-navbar">
                                <div className="avatar-container">
                                  {item?.updated_by_photo_url_xx ?
                                    <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" />
                                    : <InitialsAvatar
                                      name={item?.updated_by_name_xx}
                                      size={30}
                                      currentTheme={currentTheme}
                                    />}
                                  <span className="username">{item?.updated_by_name_xx}</span>
                                </div>
                                <span className="time-ago">{item?.time_ago_xx}</span>
                              </div>
                              <div className="remarks">
                                {item?.trc_remarks}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
          <Collaborator
            open={isCollabOpen}
            docType={"Receipt"}
            docNo={hdNo}
            docId={receiptData?._id}
            currentTheme={currentTheme}
            onClose={closeCollab}
            rightOffset={collabRightOffset}
            currentUser={currentUser}
          />
        </div>
      )}
      {validationMsgDialog && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-content">
              <ValidationMessages
                messageData={validationMessagesResult}
                onClose={() => setValidationMsgDialog(false)}
                onFix={(row) => {/* focus field / navigate */ }}
                onRemind={() => setValidationMsgDialog(false)}
                onSupport={() => navigate("/support")}
              />
            </div>
          </div>
        </motion.div>)}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notifyDialogText) }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            endIcon={<MdClose />}
            onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(objectToAction.action_text) }} />
        }
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        </motion.div>)}
      {/* email component */}
      {emailDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('email').toUpperCase()}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroup={receiptData?.report_group}
                documentData={{
                  docNo: hdNo,
                  docType: "AR Receipt",
                  docId: receiptDocId,
                  receipt_docid: receiptDocId,
                  clientEmail: receiptData?.client_details_xx?.ent_email || hdMiscEmail,
                  clientPhoneNo: receiptData?.client_details_xx?.ent_phone_no || hdMiscPhone,
                  clientEntCode: hdEntCode?.value,
                  clientEntName: hdEntCode?.label?.props?.children[0]
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isConfettiActive && <Confetti />}
    </motion.div>
  );
};


export default ArReceipt;
